import axiosInstance from '@/utils/api.js'

var state = {
  dhcpLease: []
}

var getters = {
  DHCP_LEASE: (state) => {
    return state.dhcpLease
  }
}

var mutations = {
  SET_DHCP_LEASE: (state, payload) => {
    state.dhcpLease = payload
  }
}

var actions = {
  GET_DHCP_LEASE: async (context, payload) => {
    let result = await axiosInstance.get('/reports/dhcp_leases?start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd +
    '&user_id=' + payload.userId +
    '&account_id=0&accounting_period_id=0' +
    '&limit=' + payload.limit +
    '&download=' + payload.download, {timeout: 45000})
    if (result.status === 200) {
      context.commit('SET_DHCP_LEASE', result.data)
    }
  },
  CLEAR_DHCP_LEASE: (context) => {
    context.commit('SET_DHCP_LEASE', [])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/reports/dhcpLease.js